<div>
    <eup-sticky-header [hideContactSelection]="true" [backToLastPage]="true"></eup-sticky-header>
    <div class="remote-application-container-root" #rootElement></div>
</div>
